import React, { useContext, useState, useRef, useEffect } from "react";
import { FaBars } from "react-icons/fa6";
import {
  RiHome6Line,
  RiGitBranchLine,
  RiTimeLine,
  RiFileTextLine,
} from "react-icons/ri";
import { FaRegUser } from "react-icons/fa";
import { IoSettingsOutline } from "react-icons/io5";
import { FiDatabase } from "react-icons/fi";
import { BiSupport } from "react-icons/bi";
import { SiAwsorganizations, SiCivicrm } from "react-icons/si";
import { MdOutlineAdminPanelSettings, MdOutlineSecurity } from "react-icons/md";
import { TbAsset, TbListCheck } from "react-icons/tb";
import { Link, useLocation, useNavigate } from "react-router-dom";
import AppContext from "../../context/AppContext";
import { RxCross2, RxDashboard } from "react-icons/rx";
import { FaHistory } from "react-icons/fa";
import { AiOutlineStock } from "react-icons/ai";
import translations from "../common/Translations";
import { createPortal } from "react-dom";
import { hasScreenAccess, getStoredPermissions } from "../../utils/permissions";
import { getLocalStorageJson } from "../../utils/parseStoredJson";

const Tooltip = ({ children, text, langMode = "en" }) => {
  const [visible, setVisible] = useState(false);
  const [pos, setPos] = useState({ top: 0, left: 0 });
  const ref = useRef();

  useEffect(() => {
    if (visible && ref.current) {
      const rect = ref.current.getBoundingClientRect();
      if (langMode === "ar") {
        setPos({
          top: rect.top + rect.height / 2,
          left: rect.left - 80, // show on LEFT side
          direction: "left",
        });
      } else {
        setPos({
          top: rect.top + rect.height / 2,
          left: rect.right + 10, // show on RIGHT side
          direction: "right",
        });
      }
    }
  }, [visible, langMode]);

  return (
    <>
      <div
        ref={ref}
        onMouseEnter={() => setVisible(true)}
        onMouseLeave={() => setVisible(false)}
        className="relative inline-block"
      >
        {children}
      </div>

      {visible &&
        createPortal(
          <div
            className="fixed z-[9999999] bg-white text-gray-800 text-xs font-medium px-3 py-1.5 rounded-lg shadow-md border border-gray-200"
            style={{
              top: `${pos.top}px`,
              left: `${pos.left}px`,
              transform: "translateY(-50%)",
              whiteSpace: "nowrap",
            }}
          >
            {text}
            {langMode === "ar" ? (
              <div className="absolute top-1/2 -translate-y-1/2 -right-1 w-2 h-2 bg-white border-t border-l border-gray-200 rotate-45"></div>
            ) : (
              <div className="absolute top-1/2 -translate-y-1/2 -left-1 w-2 h-2 bg-white border-t border-l border-gray-200 rotate-45"></div>
            )}
          </div>,
          document.body
        )}
    </>
  );
};

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const DashboardMenus = ({ setShowNames = () => { }, showNames = false }) => {
  const { theme, langMode, userType, currentLocationRef } = useContext(AppContext);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const sidebarRef = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();
  const [screenSize, setScreenSize] = useState(false);
  const storedPermissions = getStoredPermissions();
  const fullAccess = storedPermissions?.fullAccess ?? false;
  const hasAccess = (screenCode) => fullAccess || hasScreenAccess(screenCode, "canView");
  const userDetail = getLocalStorageJson("userDetails") || {};

  useEffect(() => {
    const updateHeightScreenSize = () => {
      if (window.innerWidth <= 1213) {
        setScreenSize(true);
      } else if (window.innerWidth > 1213) {
        setScreenSize(false);
      } else {
        setScreenSize(false);
      }
    };
    updateHeightScreenSize();
    window.addEventListener('resize', updateHeightScreenSize);
    return () => window.removeEventListener('resize', updateHeightScreenSize);
  }, []);

  const menus = [

    {
      icon: (
        <FaRegUser
          className={`  ${theme === "dark"
            ? "dark-mode"
            : theme === "high-contrast"
              ? "high-contrast"
              : ""
            }`}
          size={20}
        />
      ),
      link: "/all-users",
      relatedPaths: ["/all-users"],
      name: translations[langMode].userlist,
      tooltip: translations[langMode].usertooltip,
      screenCode: "USER_MANAGEMENT",
      isPermission: hasAccess("USER_MANAGEMENT"),
    },
    // {
    //   icon: (
    //     <MdOutlineAdminPanelSettings
    //       className={`  ${theme === "dark"
    //         ? "dark-mode"
    //         : theme === "high-contrast"
    //           ? "high-contrast"
    //           : ""
    //         }`}
    //       size={20}
    //     />
    //   ),
    //   link: "/role-management",
    //   relatedPaths: ["/role-management"],
    //   name: translations[langMode].roleManagement,
    //   tooltip: translations[langMode].roleManagementtooltip,
    //   screenCode: "ROLE_MANAGEMENT",
    //   isPermission: hasAccess("ROLE_MANAGEMENT"),
    // },

    {
      icon: <SiCivicrm size={20} className={theme} />,
      link: "/call-center/tickets",
      relatedPaths: [
        "/call-center/inbox",
        "/call-center/tickets",
        "/call-center/campaigns",
        "/call-center/agent-workspace",
        "/call-center/settings",
      ],
      name: "Call Center",
      tooltip: "Call Center",
      screenCode: "CC_INBOX",
      isPermission:
        hasAccess("CC_INBOX") ||
        hasAccess("CC_CAMPAIGNS") ||
        hasAccess("CC_AGENT_WORKSPACE") ||
        hasAccess("CC_SETTINGS"),
    },
  ];




  const handleNavigation = (nextPath, onClickHandler) => {
    if (onClickHandler) {
      onClickHandler();
      return;
    }

    const prevPath = currentLocationRef.current?.pathname || location.pathname;
    const isBlocked =
      prevPath?.startsWith('/update-complete-task') &&
      prevPath !== nextPath;

    if (isBlocked) {
      window.dispatchEvent(new CustomEvent("blockNavigation", {
        detail: { nextPath }
      }));
      return;
    }

    currentLocationRef.current = { pathname: nextPath };
    navigate(nextPath);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        setShowNames(false);
      }
    };
    if (showNames) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showNames]);

  useEffect(() => {
    setIsSidebarOpen(false);
  }, [location]);
  const filteredMenus = menus.filter((menu) => menu.isPermission !== false);
  return (

    <>
      {showNames && (
        <div className="fixed inset-0 z-40 bg-black bg-opacity-5 transition-all duration-300" />
      )}
      {isSidebarOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-10 transition-all duration-300" />
      )}
      <div
        ref={sidebarRef}
        className={`relative bg-[#EBF5FF]
          ${showNames
            ? "lg:w-[210px] opacity-100 h-full"
            : "lg:w-[45px] opacity-100 md:ps-0 sm:ps-0 ps-0"
          }
          ${isSidebarOpen
            ? "w-[210px] opacity-100 h-[630px] p-[11px]"
            : "w-0 opacity-100"}
          ${theme === "dark"
            ? "dark-mode"
            : theme === "high-contrast"
              ? "high-contrast"
              : ""}
          ${theme === "dark" && showNames
            ? "dark-mode"
            : theme === "high-contrast"
              ? "high-contrast"
              : ""
          }`}>
        {screenSize &&
          <div
            className={`relative flex items-center  transition-all origin-top-left duration-300 ease-in-out !top-2
            ${showNames
                ? "lg:w-[200px] opacity-100 bg-[#EBF5FF] rounded-t-md"
                : "lg:w-[45px] opacity-100"}
            ${isSidebarOpen
                ? "w-[200px] opacity-100 bg-[#EBF5FF] rounded-t-md"
                : "w-0 opacity-100"}
            ${theme === "dark"
                ? "dark-mode"
                : theme === "high-contrast"
                  ? "high-contrast"
                  : ""
              }`}
            style={{
              zIndex: 8888,
              top: (isSidebarOpen || showNames) ? "0px" : "63px",
              justifyContent: (isSidebarOpen || showNames) ? "end" : "start",
              height: "30px",
              background: "transparent",


            }}>
            <button
              className={`lg:hidden flex items-center px-3 py-3 absolute md:!left-1/2 sm:!left-1/2 !left-1/2 md:translate-x-1/2 sm:translate-x-1/2 translate-x-1/2 ${theme === "dark" ? "dark-mode" : ""}`}
              onClick={() => setIsSidebarOpen((prev) => !prev)}
            >
              {isSidebarOpen ? (
                <RxCross2 size={20} className={`${theme === "dark" ? "dark-mode" : ""} text-gray-700 ml-3`} />
              ) : (
                <RxDashboard size={20} className={`${theme === "dark" ? "dark-mode" : ""} text-gray-700`} />
              )}
            </button>
          </div>}
        <div
          className={`absolute top-0 left-0 z-50 h-full origin-top-left transition-all duration-300 ease-in-out
            ${theme === "dark"
              ? "dark-mode"
              : theme === "high-contrast"
                ? "high-contrast"
                : ""}
            ${showNames
              ? "lg:w-[210px] opacity-100 bg-[#EBF5FF]"
              : "lg:w-[45px] opacity-100"}
            ${isSidebarOpen
              ? "w-[210px] opacity-100 bg-[#EBF5FF] !h-[98.3vh] py-[25px] px-[10px]"
              : "w-0 opacity-100 pointer-events-none md:pointer-events-auto"}
              ${screenSize ? (!isSidebarOpen && !showNames) ? "hidden" : "" : ""}
                `}
          style={{ zIndex: 8888 }} >
          <div className={`flex items-center ${(showNames || isSidebarOpen) ? "justify-center py-2 mt-2" : "justify-center py-2"}`}>
            <Link to="/all-users">
              {(showNames || isSidebarOpen) ? (
                <img
                  src='https://res.cloudinary.com/dpdvpazfv/image/upload/v1753344904/Bluefield_x0jmp9.png'
                  alt="Logo"
                  className="h-8 mb-3"
                />
              ) : (
                <img
                  src='https://res.cloudinary.com/dpdvpazfv/image/upload/v1753344907/logo_iiqugo.png'
                  alt="Logo"
                  className={`h-10 ${theme === "dark" ? "dark-mode-img" : ""}`}
                />
              )}
            </Link>
          </div>
          {!isSidebarOpen && !showNames && (
            <div
              onClick={() => setShowNames(true)}
              className="flex items-center py-2 px-3 cursor-pointer "
            >
              <FaBars />
            </div>
          )}
          {filteredMenus.map((menu, index) => {
            const isActive =
              location.pathname === menu.link ||
              menu.relatedPaths.includes(location.pathname);
            const menuItem = (
              <div
                className={classNames(
                  "flex items-center py-2 px-3 text-sm justify-left cursor-pointer transition-all duration-300 transform hover:scale-110 hover:text-blue-600",
                  isActive ? "bg-[#236DB4] rounded-[8px] text-white" : "",
                  showNames ? "mx-3 py-3 hover:text-blue-600" : ""
                )}
                onClick={() => handleNavigation(menu.link, menu.onClick)}
              >
                {menu.icon}
                {(showNames || isSidebarOpen) && (
                  <span
                    className={`ml-3 text-sm font-medium ${isActive ? "text-white" : ""
                      }`}
                  >
                    {menu.name}
                  </span>
                )}
              </div>
            );
            return (
              <div
                key={index}
                className={`relative text-[#111827] ${menu.isPermission === false ? "hidden" : ""
                  }`}
              >
                {(!showNames && !isSidebarOpen) ? (
                  <Tooltip text={menu.name} langMode={langMode} >{menuItem}</Tooltip>
                ) : (
                  menuItem
                )}
              </div>
            );
          })}

        </div>
      </div >
    </>
  );
};

export default DashboardMenus;
